
function customCounter(){
    const counters = document.querySelectorAll('.counter');

    const options = {
        threshold: 0.5
    };

    // Prüfen, ob Nutzer Animationen reduzieren möchte
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const counter = entry.target;
                const target = +counter.getAttribute('data-target');

                if (prefersReducedMotion) {
                    // Wenn der Nutzer Animationen reduziert möchte, Zielwert direkt setzen
                    counter.textContent = target.toLocaleString('de-DE');
                } else {
                    // Animation abspielen
                    const duration = 2000;
                    const steps = 60;
                    let count = 0;
                    let increment = target / steps;
                    let stepTime = duration / steps;

                    if (!counter.classList.contains('counted')) {
                        counter.classList.add('counted');

                        const interval = setInterval(() => {
                            count += increment;
                            if (count >= target) {
                                count = target;
                                clearInterval(interval);
                            }
                            counter.textContent = Math.floor(count).toLocaleString('de-DE');
                        }, stepTime);
                    }
                }                
            }
        });
    }, options);

    counters.forEach(counter => {
        observer.observe(counter);
    });

}

export default customCounter;